import { ActionDispatching, LoadOptions } from 'app/types-shared';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { api } from '../api';
import {
  RequestCodetable, ReceiveCodetable, FailCodetable
} from './action-types';
import { mapListToStore } from './map-to-store';
import { codeFieldIncludeInactive } from 'app/area/codetable/common/codetable-options-handler/constants';
import { CodeFieldWireKey, CodeFieldFlagWireKey } from 'app/area/codetable/types-store';

export const actionCreators = {

  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestCodetable(id, loadOptionsParams));

      try {
        const query = loadOptionsParams && loadOptionsParams.query || undefined;
        const parentId = loadOptionsParams && loadOptionsParams.parentId || undefined;
        const siblingId = loadOptionsParams && loadOptionsParams.siblingId || undefined;
        const displayNotSelected = loadOptionsParams && loadOptionsParams.displayNotSelected;
        const includeNotSelected = loadOptionsParams && loadOptionsParams.includeNotSelected;
        const ignoreCategoryFilters = loadOptionsParams && loadOptionsParams.ignoreCategoryFilters;
        const includeInactiveCodes = (loadOptionsParams && loadOptionsParams.includeInactiveCodes) || codeFieldIncludeInactive.active;
        const limitFieldsTo = loadOptionsParams?.limitFieldsTo || [CodeFieldWireKey.code, CodeFieldFlagWireKey.colour];

        const [codes, path] = await Promise.all([
          api.loadCodeItems({
            id: codetableId,
            parentId,
            siblingId,
            query,
            includeInactiveCodes,
            ignoreCategoryFilters,
            categoryId: loadOptionsParams && loadOptionsParams.categoryId,
            limitFieldsTo,
            ...(displayNotSelected !== undefined && { displayNotSelected }),
            ...(includeNotSelected !== undefined && { includeNotSelected })
          }),
          siblingId !== undefined || parentId !== undefined
            ? api.loadPath(codetableId, siblingId || parentId)
            : Promise.resolve(undefined)]);

        const wireCodes = codes && codes.results || [];
        const pathCodes = codeItemToStoreValue(path || {});
        const storeCodes = mapListToStore(wireCodes, pathCodes);

        dispatch(new ReceiveCodetable(id, loadOptionsParams, storeCodes));
      } catch (err) {

        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailCodetable(id, loadOptionsParams));
      }
    }
};
